import { render } from "./UsageMessages.vue?vue&type=template&id=4d45ad24"
import script from "./UsageMessages.vue?vue&type=script&lang=js"
export * from "./UsageMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/usage/UsageMessages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d45ad24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d45ad24', __exports__)) {
    api.reload('4d45ad24', __exports__)
  }
  
  module.hot.accept("./UsageMessages.vue?vue&type=template&id=4d45ad24", () => {
    api.rerender('4d45ad24', render)
  })

}


export default __exports__